/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxcProxyvoteV1ProxyJobEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXC_PROXYVOTE_V1_PROXY_JOB_EVENT_ENTITY_NAME = 'ixc.proxyvote.v1.ProxyJobEvent';
export const ixcProxyvoteV1ProxyJobEventEntity = new schema.Entity<IxcProxyvoteV1ProxyJobEvent>(IXC_PROXYVOTE_V1_PROXY_JOB_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxcProxyvoteV1ProxyJobEvent) => `${entity.metadata?.eventId}` });

